// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение)
// AttrCrossGrid v2 — чистая логика (без Vue, DOM и стора), контракт ie-dm7 SPEC «Контракт AttrCrossGrid v2» (25.10 ≈16:25Z, бэк PR #468):
//   * cell_value_options: [binding, …] — поля плоской таблицы, которые можно показать в ячейке (первый = cell_value_binding); выбор — viewParams.<шахматка>.cell_value,
//     подписи — заголовки колонок грида cell_grid_name по binding (title_<язык>, иначе перевод title); ячейка показывает и правит ВЫБРАННОЕ поле строки;
//   * cell_use_binding: 'use' — подсвечены ячейки, где поле true; '' — подсвечены ячейки с непустым значением выбранного поля; параметра нет — без подсветки (v1);
//   * rows_grid_name / columns_grid_name / cell_grid_name — гриды формы для взаимного выделения (ячейка шахматки ↔ строка узла, строка поля / горизонта, ячейка плоской таблицы).
// Параметров v2 нет — всё как в v1: нет списка — нет выпадашки, нет имён гридов — нет взаимного выделения. Выключатель fe.ux.crossGridV2 (дефолт ВКЛ; выкл — v1).
// Юнит-тест: node --test tests/unit/crossGridV2.test.mjs
import { getPath, localized, isEmptyValue, findCellRow } from './crossGrid'

export const CG_FLAG_V2 = 'fe.ux.crossGridV2'
export function crossGridV2On(setting) {
    try { return (typeof setting === 'function' ? setting(CG_FLAG_V2, true) : true) !== false } catch (e) { return true }
}

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const hasKey = (k) => k !== undefined && k !== null && k !== ''
const str = (v) => (typeof v === 'string' ? v : '')

// cg2Config: параметры v2 (ключи атрибута; запасной — attr.params.<ключ>). options — список без пустых и повторов, cell_value_binding первым (нет в списке — добавляется);
// use_binding: строка (в т.ч. '' — подсвечивать непустые) или null — параметр не объявлен (подсветки нет)
export function cg2Config(attr, cellValueBinding) {
    const a = isObj(attr) ? attr : {}
    const p = isObj(a.params) ? a.params : {}
    const has = (k) => a[k] !== undefined && a[k] !== null
    const pick = (k) => (has(k) ? a[k] : (p[k] !== undefined && p[k] !== null ? p[k] : undefined))
    const def = str(cellValueBinding)
    let options = []
    const raw = pick('cell_value_options')
    if (Array.isArray(raw)) {
        const seen = new Set()
        for (const x of raw) {
            const b = typeof x === 'string' ? x.trim() : (isObj(x) && typeof x.binding === 'string' ? x.binding.trim() : '')
            if (b && !seen.has(b)) { seen.add(b); options.push(b) }
        }
        if (options.length && def && options[0] !== def) options = [def, ...options.filter((b) => b !== def)]
    }
    const ub = pick('cell_use_binding')
    return {
        options,
        use_binding: typeof ub === 'string' ? ub.trim() : null,
        rows_grid: str(pick('rows_grid_name')).trim(),
        columns_grid: str(pick('columns_grid_name')).trim(),
        cell_grid: str(pick('cell_grid_name')).trim(),
    }
}

// cg2Pick: выбранное поле — сохранённое (если оно в списке), иначе поле по умолчанию (cell_value_binding)
export function cg2Pick(options, saved, def) {
    if (Array.isArray(options) && typeof saved === 'string' && saved && options.includes(saved)) return saved
    return def
}

// cg2ValueCfg: конфигурация шахматки для выбранного поля. Поле по умолчанию — конфигурация как есть (v1). Другое поле — ячейка читает и пишет ЕГО:
// словарь — relation_segment его колонки плоской таблицы (cell_relation_segment / cell_items_source / cell_value_attr_type относятся к полю по умолчанию),
// cell_clear (use: false) не прячет значение (ячейка показывает поле так же, как плоская таблица), очистка не удаляет строку (cell_delete_on_clear — только у основного поля:
// очистка подписи связи не удаляет связь).
// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (ответ ie-dm7 #104764): cell_create_defaults — умолчания СТРОКИ (use: true, sign: 1):
// новая строка получает их всегда, при любом показанном поле, плюс значение показанного поля (оно главнее умолчания того же поля); правка УЖЕ существующей строки другим полем
// умолчаний не ставит (cell_defaults_create_only — правка роли не включает участие). cg2_main — основное поле: стиль блока считается по строке, не по показанному полю (cgCellStyle)
export function cg2ValueCfg(cfg, field) {
    if (!cfg || !field || field === cfg.cell_value_binding) return cfg
    return { ...cfg, cell_value_binding: field, cell_relation_segment: null, cell_items_source: null, cell_value_attr_type: null, cell_clear: null, cell_defaults_create_only: true, cell_delete_on_clear: false, cg2_field: field, cg2_main: cfg.cell_value_binding }   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение)
}

// cg2Kind: тип ячейки для НЕ основного поля по его колонке плоской таблицы: AttrBool — флажок, AttrLink или словарь — ссылка, иначе — текст (значение как есть)
export function cg2Kind(decl, hasDict) {
    const dt = decl && decl.attr_type
    if (dt === 'AttrBool') return 'bool'
    if (dt === 'AttrLink' || hasDict) return 'link'
    return 'text'
}
// cg2TextAttr: описание листа текстового поля — число остаётся числом, остальное — строка
export function cg2TextAttr(decl) {
    return { attr_type: decl && decl.attr_type === 'AttrNumber' ? 'AttrNumber' : 'AttrStr' }
}

// cg2FindGrid: описание грида формы по имени (name) с колонками; нет — по binding таблицы (как findCellDecl плоского режима)
export function cg2FindGrid(viewAttrs, name, tableBinding) {
    const kids = (n) => (n && Array.isArray(n.attrs)) ? n.attrs : []
    const dfs = (list, pred) => {
        for (const n of list || []) {
            if (!isObj(n)) continue
            if (pred(n)) return n
            const r = dfs(kids(n), pred)
            if (r) return r
        }
        return null
    }
    const list = Array.isArray(viewAttrs) ? viewAttrs : []
    return (name ? dfs(list, (n) => n.name === name && kids(n).length > 0) : null)
        || (tableBinding ? dfs(list, (n) => n.binding === tableBinding && kids(n).length > 0) : null)
}
// cg2ColumnDecl: колонка грида по binding (в любой глубине групп колонок)
export function cg2ColumnDecl(gridDecl, binding) {
    if (!gridDecl || !binding) return null
    const walk = (list) => {
        for (const n of list || []) {
            if (!isObj(n)) continue
            if (n.binding === binding) return n
            const r = walk(n.attrs)
            if (r) return r
        }
        return null
    }
    return walk(gridDecl.attrs)
}
// cg2Options: пункты выпадашки [{ key: binding, title }] — заголовок колонки плоской таблицы на языке пользователя (title_<язык>, иначе t(title)), нет колонки — binding
export function cg2Options(options, gridDecl, lang, t) {
    const tr = typeof t === 'function' ? t : (s) => s
    return (options || []).map((b) => {
        const col = cg2ColumnDecl(gridDecl, b)
        const own = col && lang ? col[`title_${lang}`] : ''
        const title = (typeof own === 'string' && own) ? own : (col && typeof col.title === 'string' && col.title ? String(tr(col.title)) : b)
        return { key: b, title }
    })
}

// ---------- подсветка участия ----------
// cg2UseOf: строка плоской таблицы (или null) участвует? use_binding 'use' — поле true; '' — непустое значение выбранного поля (флажок — true); null — не подсвечиваем
export function cg2UseOf(row, cfg, useBinding) {
    if (useBinding === null || useBinding === undefined || !isObj(row)) return false
    if (useBinding) return getPath(row, useBinding) === true
    const v = getPath(row, cfg.cell_value_binding)
    return cfg.kind === 'bool' ? v === true : !isEmptyValue(v)
}
// cg2CellUse: ячейка шахматки (строка источника × ключ колонки) подсвечена?
export function cg2CellUse(srcRow, colKey, cfg, useBinding) {
    if (useBinding === null || useBinding === undefined || !srcRow || !hasKey(colKey)) return false
    const { row } = findCellRow(srcRow, colKey, cfg)
    return cg2UseOf(row, cfg, useBinding)
}

// ---------- взаимное выделение ----------
const same = (a, b) => hasKey(a) && hasKey(b) && String(a) === String(b)
// cg2KeyPos: строка грида узлов / полей / горизонтов с ключом key (items — dataItem строк грида по порядку)
export function cg2KeyPos(items, key, keyBinding) {
    if (!Array.isArray(items) || !hasKey(key)) return -1
    for (let i = 0; i < items.length; i++) if (isObj(items[i]) && same(getPath(items[i], keyBinding), key)) return i
    return -1
}
// cg2CellPos: строка плоской таблицы с парой ключей (ключ строки шахматки, ключ колонки); дубль пары — первая (как у шахматки)
export function cg2CellPos(items, rowKey, colKey, cfg) {
    if (!Array.isArray(items) || !hasKey(rowKey) || !hasKey(colKey) || !cfg) return -1
    for (let i = 0; i < items.length; i++) {
        const it = items[i]
        if (isObj(it) && same(getPath(it, cfg.cell_rows_key_binding), rowKey) && same(getPath(it, cfg.cell_columns_key_binding), colKey)) return i
    }
    return -1
}
// cg2ColPos: колонка грида по binding поля (bindings — binding колонок грида по порядку)
export function cg2ColPos(bindings, binding) {
    return Array.isArray(bindings) && binding ? bindings.indexOf(binding) : -1
}
// cg2CellKeys: ключи ячейки шахматки по строке плоской таблицы
export function cg2CellKeys(item, cfg) {
    if (!isObj(item) || !cfg) return null
    const rk = getPath(item, cfg.cell_rows_key_binding), ck = getPath(item, cfg.cell_columns_key_binding)
    return hasKey(rk) || hasKey(ck) ? { rk: hasKey(rk) ? rk : null, ck: hasKey(ck) ? ck : null } : null
}
// cg2CrossPos: ячейка шахматки по ключам — строка проекции с ключом строки (повтор ключа — первая), лист с ключом колонки (дубль — первый); ключа нет — null (оставить текущую)
// vmItems — dataItem строк шахматки по порядку, leaves — листья buildColumns. → { row: индекс | null, leaf: binding | null }
export function cg2CrossPos(vmItems, leaves, rowKey, colKey) {
    let row = null, leaf = null
    if (hasKey(rowKey) && Array.isArray(vmItems)) {
        for (let i = 0; i < vmItems.length; i++) { const it = vmItems[i]; if (isObj(it) && !it.cg_dupKey && same(it.cg_key, rowKey)) { row = i; break } }
    }
    if (hasKey(colKey) && Array.isArray(leaves)) {
        const l = leaves.find((x) => x && !x.dup && x.key !== null && same(x.key, colKey))
        if (l) leaf = l.binding
    }
    return { row, leaf }
}
// cg2Targets: что выделить в гридах формы по ячейке шахматки (строка проекции × лист; лист null — колонка заголовка): ключи и поле плоской таблицы
export function cg2Targets(vmRow, leaf, field) {
    const rk = vmRow && hasKey(vmRow.cg_key) ? vmRow.cg_key : null
    const ck = leaf && hasKey(leaf.key) ? leaf.key : null
    return { rows: rk, columns: ck, cell: rk !== null && ck !== null ? { rk, ck, field } : null }
}

// ---------- ответы ie-dm7 #104764 (IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение)) ----------
// cg2SetField: выбор поля в «Показувати ▾» — настройка вида, запись НЕ помечается изменённой (Save не загорается): viewParams.<шахматка>.cell_value через
// store.set_viewParam(…, set_modified = false), как кнопка «Classic / Lens» графа (lens/lensSwitch.graphEngine_set); на бэк уходит вместе с ближайшим Save записи
export function cg2SetField(store, WIDGET, name, field, attr) {
    if (!store || typeof store.set_viewParam !== 'function' || !field) return false
    store.set_viewParam(WIDGET, name, 'cell_value', field, attr, false)
    return true
}
// cg2NoRowKey: строки плоской таблицы без ключа строки (рёбра без source — факты, меры баланса): в матрицу не попадают по устройству данных (входят в orphans у flatAudit)
export function cg2NoRowKey(table, cfg) {
    if (!Array.isArray(table) || !cfg || !cfg.cell_rows_key_binding) return 0
    let n = 0
    for (const r of table) if (isObj(r) && !hasKey(getPath(r, cfg.cell_rows_key_binding))) n++
    return n
}
// cg2TableTitle: подпись плоской таблицы для текстов — заголовок её грида на форме (title_<язык>, иначе t(title)); нет грида / заголовка — binding таблицы
export function cg2TableTitle(gridDecl, lang, t, fallback) {
    const tr = typeof t === 'function' ? t : (s) => s
    const own = gridDecl && lang ? gridDecl[`title_${lang}`] : ''
    if (typeof own === 'string' && own) return own
    if (gridDecl && typeof gridDecl.title === 'string' && gridDecl.title) return String(tr(gridDecl.title))
    return str(fallback)
}
// cg2InfoText: сведение (не предупреждение) о строках без ключа строки: матрица узел × узел (rows_binding = columns_binding) — «связи без узла-источника»,
// иначе — нейтральный текст о строках таблицы без строки матрицы; n = 0 — ''. t(ключ, { n, table }) — перевод с подстановкой
export function cg2InfoText(n, cfg, table, t) {
    if (!(n > 0) || !cfg || typeof t !== 'function') return ''
    if (cfg.rows_binding && cfg.rows_binding === cfg.columns_binding) return String(t('{n} links without a source node (facts, balance measures) - only in the table "{table}"', { n, table }))
    return String(t('{n} rows of the table "{table}" are not tied to a matrix row - only in that table', { n, table }))
}

// ---------- проба dev02 fe-2026-10-25-25 (IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение)) ----------
// D3: перечисление в описании колонки плоской таблицы — AttrLink со встроенным itemsSource [{ id, title, title_uk, title_ru }] без relation_segment (dim_role, presence,
// approval_unit): словарь ячейки — эти элементы (подписи на языке пользователя), а не сырые id. cell_items_source объявления шахматки главнее
export function cg2DeclItems(decl) {
    if (!isObj(decl) || !Array.isArray(decl.itemsSource)) return null
    const out = decl.itemsSource.filter((x) => isObj(x) && x.id !== undefined && x.id !== null)
    return out.length ? out : null
}
export function cg2ItemsSource(cfg, decl) {
    if (cfg && Array.isArray(cfg.cell_items_source) && cfg.cell_items_source.length) return cfg.cell_items_source
    return cg2DeclItems(decl) || (cfg ? cfg.cell_items_source : null)
}
